<template>
    <rkm-data-table

        :fields="fields"
        :repository="repositories.servicoManutencao"
        ref="RkmDataTable"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{item}">
            <rkm-button
                @click="edit(item.id)"
                authorize="update-cadastro-servico-manutencao"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                :disabled="!!item.allowDestroy"
                @click="destroy(item)"
                authorize="destroy-cadastro-servico-manutencao"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>

// Mixins.
import {error, formats, repository, stringCase} from '@/mixins'

export default {
    created() {
        this.repositories = {
            servicoManutencao: this.getConectaSusRepository('cadastro.servicoManutencao'),
        }
    },
    data: () => ({
        fields: [
            {key: 'nome', label: 'Nome', name: 'nome', searchable: true, sortable: true},
            {key: 'grupoNome', label: 'Grupo', name: 'grupoNome', searchable: true, sortable: true},
            {key: 'subGrupoNome', label: 'Sub-grupo', name: 'subGrupoNome', searchable: true, sortable: true},
            {key: 'prioridadeNome', label: 'Prioridade', name: 'prioridadeNome', searchable: true, sortable: true},
            {class: 'col-min', key: 'actions', label: 'Ações', name: 'actions'},
        ],
    }),
    methods: {
        edit(id) {

            this.$router.push({name: 'cadastro-servico-manutencao-edit', params: {id}})
        },
        destroy(item) {

            const destroy = () => this.repositories.servicoManutencao.destroy(item.id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir a unidade?', destroy)
        },
    },
    mixins: [error, formats, repository, stringCase],
}
</script>